// Avertissement « le JavaScript ne démarre pas » (2 s) et signalement des exceptions dans le cadre rouge.
var warningTimer = setTimeout(function() {
    var w = document.getElementById('js-warning');
    if (w) w.style.display = 'block';
}, 2000);
// initApp l'annule dès que le moteur tourne (la variable est privée à ce module).
export function stopperAvertissementJs() { clearTimeout(warningTimer); }
window.stopperAvertissementJs = stopperAvertissementJs;

// Une exception de programmation, montrée dans le cadre rouge de la page (window.onerror) avec son origine.
window.signalerErreur = function(e, origine) {
    var msg = (e && e.message) || String(e), ligne = 0, m = /app(?:\.bundle)?\.js[^:]*:(\d+)/.exec((e && e.stack) || '');
    if (m) ligne = parseInt(m[1], 10);
    try { console.error('Erreur dans le traitement de « ' + origine + ' » :', e); } catch (x) {}
    if (typeof window.onerror === 'function') window.onerror('[' + origine + '] ' + msg, 'app.js', ligne, 0, e);
};

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const signalerErreur = window.signalerErreur;
